import { useLocation } from "react-router-dom";
import qs from 'qs';
import logo from '../../resources/logo.png';
import { useEffect } from "react";
import { formatCurrency } from "../../utils/CurrencyUtils";

const CreditReceipt = () => {
    const location = useLocation();

    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
    const client = typeof queryParams.clientInfo === 'string' ? JSON.parse(queryParams.clientInfo) : queryParams.clientInfo;
    const customer = typeof queryParams.customer === 'string' ? JSON.parse(queryParams.customer) : queryParams.customer;
    const grade = typeof queryParams.grade === 'string' ? JSON.parse(queryParams.grade) : queryParams.grade;
    const credit = typeof queryParams.currentCredit === 'string' ? JSON.parse(queryParams.currentCredit) : queryParams.currentCredit;
    const transactionsRaw = Array.isArray(queryParams.transactions) ? queryParams.transactions : [queryParams.transactions];
    const transactions = transactionsRaw.filter(Boolean).map(t => (typeof t === 'string' ? JSON.parse(t) : t));
    const totalAmount = Number(queryParams.totalAmount) || 0;
    const operator = queryParams.operator;
    const auto_print = queryParams.auto_print !== undefined && queryParams.auto_print !== 'false';

    const isRecharge = transactions?.[0]?.transaction_type === "Credit Recharge Admin";

    const creditAfter = Number(credit) || 0;
    const value = Number(totalAmount) || 0;

    const saldoAntes = isRecharge ? (creditAfter - value) : creditAfter;
    const saldoAtual = isRecharge ? creditAfter : (creditAfter + value);

    useEffect(() => {
        if (auto_print) {
            const timer = setTimeout(() => {
                window.print();
            }, 1000);

            return () => clearTimeout(timer);
        }
    }, [auto_print]);

    const handleCopy = () => {
        const lines = [];

        lines.push(`*${client.client_name.toUpperCase()}*`);
        lines.push(client.address);
        lines.push(`Fone: ${client.phone_number}`);
        lines.push(`CNPJ: ${client.cnpj}`);
        lines.push('-----------------------------');
        lines.push(`Emitido em: ${new Date().toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })} ${new Date().toLocaleTimeString('pt-BR', { timeZone: 'America/Sao_Paulo' })}`);

        lines.push('-----------------------------');
        lines.push(`*COMPROVANTE DE RECARGA*`);
        lines.push(`Cliente: ${customer}`);
        if (grade) lines.push(`Série: ${grade}`);

        lines.push('-----------------------------');
        lines.push(`*MÉTODO DE PAGAMENTO*`);
        transactions.forEach((transaction) => {
            const v = Number(transaction.value) || 0;
            lines.push(`${transaction.paymentMethod}: ${v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`);
        });

        lines.push('-----------------------------');
        lines.push(`*SALDO ANTES DA RECARGA:* ${formatCurrency(saldoAntes)}`);
        lines.push(`${saldoAtual < 0 ? '*SALDO DEVEDOR:*' : '*SALDO ATUAL DO ALUNO:*'} ${formatCurrency(saldoAtual)}`);
        lines.push('-----------------------------');
        lines.push(`Operador: ${operator}`);
        lines.push('-----------------------------');

        const receiptText = lines.join('\n');
        navigator.clipboard.writeText(receiptText);
    };

    return (
        <div className="w-full h-full p-4 bg-white text-sm font-mono">
            <div className="print:hidden mb-4 flex justify-center items-center">
                <button
                    id="copy-button"
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                    onClick={handleCopy}
                >
                    Copiar Recibo
                </button>
            </div>

            <div id="content">
                <div className="mb-4">
                    <p className="font-bold uppercase text-center">{client.client_name}</p>
                    <p className="text-center">{client.address}</p>
                    <p className="text-center">{client.phone_number}</p>
                    <p className="text-center">CNPJ: {client.cnpj}</p>
                </div>

                <div className="flex justify-between items-center font-bold border-t border-dashed border-gray-300 py-2">
                    <p>EMITIDO EM</p>
                    <p>{new Date().toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })} {new Date().toLocaleTimeString('pt-BR', { timeZone: 'America/Sao_Paulo' })}</p>
                </div>

                <div className="border-t border-dashed border-gray-300">
                    <p className="font-bold text-center my-2">COMPROVANTE DE RECARGA</p>
                    <p className="text-center mb-2">Cliente: {customer}</p>
                    {grade && <p className="text-center mb-2">Série: {grade}</p>}
                </div>

                <div className="border-t border-b border-dashed border-gray-300 my-2">
                    {transactions.map((transaction, index) => (
                        <div key={index} className="my-2">
                            <p className="flex justify-between">
                                <span>MÉTODO DE PAGAMENTO</span>
                                <span>{transaction.paymentMethod}</span>
                            </p>
                            <p className="flex justify-between">
                                <span>VALOR PAGO</span>
                                <span>{formatCurrency(Number(transaction.value) || 0)}</span>
                            </p>
                        </div>
                    ))}

                    <div className="font-bold border-dashed border-gray-300 py-2">
                        <p className="font-bold text-right flex justify-between">
                            <span>SALDO ANTES DA RECARGA</span>
                            <span>{formatCurrency(saldoAntes)}</span>
                        </p>
                        <p className="flex justify-between">
                            <span>{saldoAtual < 0 ? 'SALDO DEVEDOR' : 'SALDO ATUAL DO ALUNO'}</span>
                            <span>{formatCurrency(saldoAtual)}</span>
                        </p>
                    </div>
                </div>

                <div>
                    <p className="flex justify-center items-center font-bold py-2">
                        <span>OPERADOR:</span>
                        <span>{operator}</span>
                    </p>
                    <img src={logo} alt='Logo Foodz' className='w-2/5 justify-self-center' />
                </div>
            </div>
        </div>
    );
};

export default CreditReceipt;